import { CubeOffOutlineIcon } from './CubeOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0A2F7725-8D0E-4C67-8EC3-03D8F92EEB33
 * name cube-off-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cube-off-outline.svg
 * tags
 * - Food / Drink 
 */
export const SugarCubeOffIcon = CubeOffOutlineIcon;
export default SugarCubeOffIcon